import { render, staticRenderFns } from "./RolePermission.vue?vue&type=template&id=074867e6&scoped=true"
import script from "./RolePermission.vue?vue&type=script&lang=js"
export * from "./RolePermission.vue?vue&type=script&lang=js"
import style0 from "./RolePermission.vue?vue&type=style&index=0&id=074867e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074867e6",
  null
  
)

export default component.exports